"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const flatControl_1 = __importDefault(require("../../functions/flatters/flatControl"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const callableIterateChildren = ({ entryVars: { tags, parent }, callbacks, executeProcesses, functionId, processor, }) => {
    const valueIsAlmostControl = (value) => {
        if (!(0, valueIsRecord_1.default)(value)) {
            return false;
        }
        if (!value.id || !value.name || !value.tag) {
            return false;
        }
        return true;
    };
    if (!valueIsAlmostControl(parent)) {
        executeProcesses(functionId, callbacks.onError, 'You didn´t select a correct parent');
        return;
    }
    if (!Array.isArray(tags)) {
        executeProcesses(functionId, callbacks.onError, 'The tags should be an array of strings');
        return;
    }
    const parentControlInfo = processor.root.getControlInfoById(parent.id);
    if (!parentControlInfo) {
        executeProcesses(functionId, callbacks.onError, `Couldn't find the control with id: ${parent}`);
        return;
    }
    const controlsInParent = (0, flatControl_1.default)({
        control: parent,
        parentControlId: parent.id,
        initialObject: {},
        path: [],
        context: parentControlInfo.context,
    });
    const isValidControl = (children) => {
        if (!children || !tags.includes(children.tag)) {
            return false;
        }
        return !(children.tag === 'View' && children.containerType === 'inner');
    };
    Object.values(controlsInParent)
        .filter((info) => isValidControl(info === null || info === void 0 ? void 0 : info.control))
        .forEach((info) => {
        executeProcesses(functionId, callbacks.onIteration, info === null || info === void 0 ? void 0 : info.control);
    });
};
exports.default = callableIterateChildren;
